







import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-minus',
  components: {}
}

@Component(config)
export default class IconMinus extends Vue {}
